import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getEnvironment, getWorkingEnvironment, setStatement, setNodes } from "../../Actions/Index";
import CustomAlert from "../Utils/CustomAlert"

import SelectTable from "../Operations/SelectTable"
import AddColumn from "../Operations/AddColumn"
import Prefix from "../Operations/Prefix"
import NewColumnName from "../Operations/NewColumnName"
import ExpressionInput from "../Operations/ExpressionInput"
import NumberInput from "../Operations/NumberInput"
import ColumnList from "../Operations/ColumnList"
import UpdateRevewSrcRadioBtn from "../Operations/UpdateRevewSrcRadioBtn"
import NewSourceName from "../Operations/NewSourceName"
import 'bootstrap/dist/css/bootstrap.min.css';


const CasecadingOperationManager = ({ Operation, selectedStatement, handleClose, Interpret, Run }) => { 
    const dispatch = useDispatch();


    const Environment = useSelector((state) => state.getEnvironment);
    const WorkingEnvironment = useSelector((state) => state.getWorkingEnvironment);

    const FileName = useSelector((state) => state.getFileName);
    const Branches = useSelector((state) => state.getBranches);
    const Statements = useSelector((state) => state.setStatement);
    const Nodes = useSelector((state) => state.setNodes);


    const [tables, setTables] = useState([]);
    const [selectedTblCols, setSelectedTblCols] = useState([]);
    const [variables, setVariables] = useState([]);
    const [updateSource, setUpdateSource] = useState(false);
    const [newSrcName, setNewSrcName] = useState("");
    const [output, setOutput] = useState({});
    const [alertData, setAlertData] = useState({
        show: false,
        variant: "success",
        heading: null,
        body: null,
        showCloseBtn: false,
        closeAfter: 0,
        className: "mt-3"
    });

    const hideAlert = () => {
        setAlertData({
            show: false,
            variant: "success",
            heading: null,
            body: null,
            showCloseBtn: false,
            closeAfter: 0,
            className: "mt-3"
        });
    }


    useEffect(() => {
        if (Environment.tables) {

            let _tables = [];
            Environment.tables.forEach(x => {
                _tables.push(x.name)
            })
            setTables(_tables);
        }
        if (Environment.variables) {
            var _variables = [];
            Object.entries(Environment.variables).map(([key, val]) => {
                _variables.push(key)
            })
            setVariables(_variables)
        }
    }, [Environment])


    useEffect(() => {
        if (WorkingEnvironment.tables) {

            let _tables = [];
            WorkingEnvironment.tables.forEach(x => {
                _tables.push(x.name)
            })
            setTables(_tables);
        }
    }, [WorkingEnvironment])

    const updateTableCols = (tableName) => {
        setSelectedTblCols(getTableData(tableName));
    }

    const getTableData = (tableName) => {
        if (Object.keys(WorkingEnvironment).length) {
            let desiredTableData = WorkingEnvironment.tables.find(x => x.name == tableName);
            if (desiredTableData) {
                return desiredTableData.columns;
            }
        }
        else {
            let desiredTableData = Environment.tables.find(x => x.name == tableName);
            if (desiredTableData) {
                return desiredTableData.columns;
            }
        }
        return [];
    }
    const createGuid = () => {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4()).toLowerCase();
    }

    const updateOutput = (Key, Value) => {
        let obj = {
            ...output
        }
        obj[Key] = Value;
        setOutput(obj);
    }

    const addStatement = () => {
        let script = eval(Operation.GenerateScript)(output);
        script = script.replaceAll(";", " ");
        handleClose(script);
    }

    function isNullOrWhitespace(input) {
        return (typeof input === 'undefined' || input == null)
            || input.replace(/\s/g, '').length < 1;
    }
    return (
        <>
            {
                Operation.Params.map((param, index) => {
                    return (
                        <div key={index}>

                            {(param.Type === 'Table') && <SelectTable param={param} tables={tables} updateOutput={updateOutput} setSelectedTblCols={updateTableCols} selectedStatement={selectedStatement} />}
                            {(param.Type === 'Column' && selectedTblCols.length) && <AddColumn param={param} tableCols={selectedTblCols} updateOutput={updateOutput} selectedStatement={selectedStatement} />}
                            {(param.Type === 'Prefix') && <Prefix param={param} updateOutput={updateOutput} selectedStatement={selectedStatement} />}
                            {(param.Type === 'VarName') && <NewColumnName param={param} updateOutput={updateOutput} selectedStatement={selectedStatement} />}
                            {(param.Type === 'Expression') && <ExpressionInput param={param} updateOutput={updateOutput} tableCols={selectedTblCols} variables={variables} prefix={Operation.Params.find(x => x.Type == 'Prefix')} selectedStatement={selectedStatement} />}
                            {(param.Type === 'number') && <NumberInput param={param} updateOutput={updateOutput} selectedStatement={selectedStatement} />}
                            {(param.Type === 'ColumnList' && selectedTblCols.length) && <ColumnList param={param} tableCols={selectedTblCols} updateOutput={updateOutput} selectedStatement={selectedStatement} />}


                        </div>
                    )
                }
                )
            }
            {/* { Operation.GeneratesResult && <UpdateRevewSrcRadioBtn updateSource={updateSource} setUpdateSource={setUpdateSource} selectedStatement={selectedStatement} />}
            {(!updateSource && Operation.Name != "Raw") && <NewSourceName newSrcName={newSrcName} setNewSrcName={setNewSrcName} selectedStatement={selectedStatement} />} */}
            <button className='btn btn-primary' onClick={addStatement}>Create casecading operation statement</button>

            <CustomAlert show={alertData.show} hideAlert={hideAlert} variant={alertData.variant} heading={alertData.heading} body={alertData.body} showCloseBtn={alertData.showCloseBtn} className={alertData.className} />
        </>
    );
}

export default CasecadingOperationManager;